import React, {
 useCallback,
 useEffect,
 useLayoutEffect,
 useState,
} from 'react';
import { useQuery, useQueryClient } from 'react-query';
import moment from 'moment';
import { ContentWrapper } from '../../_common';
import { ZoomInIcon, ZoomOutIcon } from '../../_assests';
import Connections from './Connections';
import {
 Content,
 Contract,
 ContractData,
 ContractZoom,
 ContractType,
 ContractNumber,
 PrintNumber,
 ContractParam,
 ContractConnections,
} from './Contracts.styled';
import { TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import DataGrid from '../../Shared/DataGrid/DataGrid';
import { ContractColumns } from '../../Shared/columns/ContractColumns';
import { ConnectionColumns } from '../../Shared/columns/ConnectionColumns';
import DialogContract from '../../dialogs/DialogContract';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import srv from '../../../services';
import SnackBar from '../../Shared/SnackBar';
import { Checkbox } from '@material-ui/core';

export default function Contracts() {
 const { contracts, maximizedContract, onMaximize } = useContracts();

 const [cardFilter, setCardFilter] = useState('');
 const [contractsArray, setContractsArray] = useState([]);
 const [mainColumns, setMainColumns] = useState(ContractColumns());
 const [detailColumns, setDetailColumns] = useState(ConnectionColumns());
 const [showGrid, setShowGrid] = useState(false);

 const openContractData = useSelector(
  (state: RootState) => state.openContract,
  shallowEqual,
 );

 const contractIdData = useSelector(
  (state: RootState) => state.contractId,
  shallowEqual,
 );

 useEffect(() => {
  const contractColumns = ContractColumns();
  const detailColumns = ConnectionColumns();

  setMainColumns(contractColumns);
  setDetailColumns(detailColumns);

  srv.getShowContractTableView().then((response) => {
   if (response && response.data) {
    setShowGrid(response.data === '0' ? false : true);
   }
  });
 }, []);

 useEffect(() => {
  srv.getShowContractTableView().then((response) => {
   if (response && response.data) {
    setShowGrid(response.data === '0' ? false : true);
   }
  });
 }, [showGrid]);

 useEffect(() => {
  if (contracts && contracts.length > 0) {
   setContractsArray(contracts);
  }
 }, [contracts]);

 const handleCardFilter = (value: any) => {
  const result = value?.currentTarget?.value;

  if (result) {
   setCardFilter(result);
   const filteredFruits = contracts.filter(
    (x: any) =>
     (x.number && x.number.includes(result)) ||
     (x.contractDate && x.contractDate.includes(result)) ||
     (x.resources && x.resources.includes(result)) ||
     (x.responsible && x.responsible.includes(result)) ||
     (x.responsibleEmail && x.responsibleEmail.includes(result)) ||
     (x.state && x.state.includes(result)) ||
     (x.status && x.status.includes(result)),
   );

   setContractsArray(filteredFruits);
  } else {
   setCardFilter('');
   setContractsArray(contracts);
  }
 };

 const showGridChangeHandle = (value: React.ChangeEvent<HTMLInputElement>) => {
  const payload = {
   newValue: `${Number(value?.target?.checked)}`,
  };

  srv.setShowContractTableView(payload).then(() => {
   setShowGrid(!showGrid);
  });
 };

 return (
  <React.Fragment>
   <ContentWrapper>
    <Content>
     <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div style={{ position: 'sticky', left: 0, top: 0 }}>
       <div
        style={{
         display: 'flex',
         flexDirection: 'row',
         marginTop: '-20px',
         alignContent: 'center',
         alignItems: 'center',
         marginLeft: '20px',
         marginBottom: '10px',
         color: '#ffb614',
         height: '40px',
         width: '100%',
        }}
       >
        <label
         style={{
          marginTop: '15px',
          marginRight: '5px',
          top: '20px !important',
          color: 'black',
          fontWeight: 600,
         }}
        >
         Показать в табличном виде
        </label>
        <Checkbox
         checked={showGrid}
         style={{
          marginTop: '15px',
          height: '40px',
          width: '40px',
          color: '#ffb614',
         }}
         onChange={showGridChangeHandle}
        />
       </div>
       {!showGrid && (
        <TextField
         size={'small'}
         label="Поиск договоров"
         placeholder="Введите данные договора"
         onChange={(e: any) => handleCardFilter(e)}
         value={cardFilter}
         InputProps={{
          startAdornment: (
           <InputAdornment position="start">
            <SearchIcon />
           </InputAdornment>
          ),
         }}
         style={{
          marginLeft: '20px',
          width: '290px',
          border: 'none',
          marginTop: '20px',
         }}
        />
       )}

       {showGrid && (
        <DataGrid
         columns={mainColumns?.columns ? mainColumns.columns : []}
         detailColumns={detailColumns?.columns ? detailColumns.columns : []}
         rows={contractsArray}
         take={20}
         page={1}
         pagination={true}
        />
       )}

       {!showGrid && (
        <div
         style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}
        >
         {contractsArray?.map((contract) => (
          <Contract
           key={contract.id}
           maximized={maximizedContract === contract.id}
          >
           <ContractZoom onClick={() => onMaximize(contract.id)}>
            {maximizedContract === contract.id ? (
             <ZoomOutIcon />
            ) : (
             <ZoomInIcon />
            )}
           </ContractZoom>

           <ContractData>
            <ContractType>
             <u>Тип договора</u> {contract.type}
            </ContractType>

            <PrintNumber>
             <u>Номер договора</u> {contract.printNumber}
            </PrintNumber>

            {/* <ContractNumber>
             <u>Системный номер</u> {contract.number}
            </ContractNumber> */}

            <ContractParam>
             <u>Дата заключения</u>{' '}
             {moment(contract.contractDate).format('DD.MM.YYYY')}
            </ContractParam>

            <ContractParam>
             <u>Автопролонгация</u> {contract.autoContinuation ? 'Да' : 'Нет'}
            </ContractParam>

            <ContractParam>
             <u>Состояние</u> {contract.state}
            </ContractParam>

            <ContractParam>
             <u>Статус</u> <label> {contract.status} </label>
            </ContractParam>
           </ContractData>

           {maximizedContract === contract.id && (
            <ContractConnections>
             <Connections contractId={contract.id} />
            </ContractConnections>
           )}
          </Contract>
         ))}
        </div>
       )}
      </div>
     </div>
    </Content>
   </ContentWrapper>

   <SnackBar vertical="top" horizontal="center" />

   {contractIdData ? (
    <DialogContract
     showSbpDialog={openContractData}
     dialogContent={
      <ContractConnections>
       <Connections contractId={contractIdData} />
      </ContractConnections>
     }
    />
   ) : (
    ''
   )}
  </React.Fragment>
 );
}

function useContracts() {
 const contracts =
  useQueryClient().getQueryData<Models.Contract[]>('contracts');

 const [maximizedContract, setMaximizedContract] = useState(null);

 const onMaximize = useCallback(
  (id) => {
   if (maximizedContract === id) {
    setMaximizedContract(null);
   } else {
    setMaximizedContract(id);
   }
  },
  [maximizedContract],
 );

 return { contracts, maximizedContract, onMaximize };
}
